const styles = theme => ({
    root: {
        margin: 0
    }
  });
  
export default styles;
  